export default "__VITE_ASSET__b5db784c__"